import { v4 as uuidv4 } from "uuid";
export class UserRegistrationModel {
    constructor() {
        this.id = uuidv4();
        this.organization = "";
        this.name = "";
        this.email = "";
        this.contactNumber = "";
        this.timeZone = "";
    }
}
export default class UserRegistration extends UserRegistrationModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
